import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  deleteErrorSecurity,
  login,
  logout,
  passwordChange,
  verify2fa,
} from '../../actions/security';
import { deleteErrorUser } from '../../actions/user';
import { localStorageConstants } from '../../constants/globals';
import { useModalToggle } from '../../hooks/useModalToggle';
import styles from '../../styles/css/Login.module.css';
import withTranslations from '../../utils/HighOrderComponent';
import ModalForAuthentification2fa from '../Security/2fa/ModalForAuthentification2fa';
import LoginForm from '../Security/LoginForm';
import LoginFormWithImageWrapper from '../Security/LoginFormWithImageWrapper';
import LoginFormWrapper from '../Security/LoginFormWrapper';
import ModalForPasswordChange from '../User/Password/ModalForPasswordChange';

const Login = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.loggedUserReducer);
  const { t, gt } = props || {},
    { Modals, Form, NotificationMessages } = t || {};

  const [username, setUsername] = useState(null);
  const [resetPassword, setResetPassword] = useState(false);

  const [showModal2faVerification, toggleModal2faVerification] =
    useModalToggle(false);

  const [showModalPasswordChange, toggleModalPasswordChange] =
    useModalToggle(false);

  const qrCode = localStorage.getItem(localStorageConstants.QR_CODE);

  useEffect(() => {
    dispatch(logout(history));
    return () => {
      dispatch(deleteErrorUser());
      dispatch(deleteErrorSecurity());
    };
  }, [dispatch, history]);

  const modalCloseHandler = () => {
    toggleModal2faVerification(false);
    dispatch(logout(history));
  };

  const onPasswordChangeModalCloseHandler = () => {
    toggleModalPasswordChange(false);
    setResetPassword(true);
  };

  const onLoginHandler = (loginRequest) => {
    setUsername(loginRequest?.username);
    dispatch(
      login(
        loginRequest,
        toggleModal2faVerification,
        toggleModalPasswordChange,
        NotificationMessages,
        history
      )
    );
  };

  const onVerification2faSubmitHandler = (verificationCode, verifierId) => {
    dispatch(
      verify2fa(verificationCode, verifierId, NotificationMessages, history)
    );
  };

  const onPasswordChangeSubmitHandler = (userPasswordChangingDTO) => {
    const passwordSubmitData = { ...userPasswordChangingDTO, username };
    dispatch(
      passwordChange(
        passwordSubmitData,
        onPasswordChangeModalCloseHandler,
        NotificationMessages
      )
    );
  };

  const Wrapper =
    process.env.REACT_APP_LOGIN_PAGE_DEFAULT === 'true'
      ? LoginFormWrapper
      : LoginFormWithImageWrapper;

  return (
    <Fragment>
      <Wrapper
        title={t.title}
        appName={gt.appName}
        loading={loading}
        styles={styles}
      >
        <LoginForm
          translations={Form}
          onLoginHandler={onLoginHandler}
          resetPassword={resetPassword}
        />
      </Wrapper>
      {showModal2faVerification && (
        <ModalForAuthentification2fa
          show={showModal2faVerification}
          hideModal={modalCloseHandler}
          title={Modals.title}
          submitHandler={onVerification2faSubmitHandler}
          qrCode={qrCode}
        />
      )}
      {showModalPasswordChange && (
        <ModalForPasswordChange
          show={showModalPasswordChange}
          hideModal={toggleModalPasswordChange}
          title={Modals.ModalForPasswordChangeTitle}
          submitHandler={onPasswordChangeSubmitHandler}
        />
      )}
    </Fragment>
  );
};

export default withTranslations(Login, 'Login');
